import React, { useEffect, useRef, useState } from 'react'
import firebase from 'firebase/app'

let Login = ({ setLoggedIn }) => {
  const emailInput = useRef(null)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [passEmailSent, setPassEmailSent] = useState(false)
  const [sendingPassResetEmail, setSendingPassResetEmail] = useState(false)
  const [showErrorText, setShowErrorText] = useState(false)
  const [inProgress, setInProgress] = useState(false)

  useEffect(() => emailInput.current.focus(), [])

  const login = async e => {
    e.preventDefault()
    setInProgress(true)

    try {
      await firebase.auth().signInWithEmailAndPassword(email, password)
      setLoggedIn(true)
    } catch (err) {
      setShowErrorText(true)
      setInProgress(false)
    }
  }

  const sendPasswordResetEmail = () => {
    setSendingPassResetEmail(true)

    firebase
      .auth()
      .sendPasswordResetEmail(email)
      .then(() => setPassEmailSent(true))
      .catch(function (error) {
        console.error({ error })
      })
  }

  const validEmail = /\S+@\S+\.\S+/.test(email)

  return (
    <div className="container mt-5">
      {/* <img
        src="https://evergreenonlineleads.com/wp-content/uploads/2018/12/Evergreen-Leads-_-LogoNew.png"
        className="mb-4 ml-3"
        style={{
          height: '20px',
        }}
        alt=""
      /> */}
      <form className="col-md-6" onSubmit={login}>
        <div className="input-group mb-2">
          <div className="input-group-prepend">
            <span className="input-group-text">
              <i className="fa fa-envelope" />
            </span>
          </div>
          <input
            ref={emailInput}
            type="email"
            className="form-control"
            id="email"
            placeholder="Email"
            onChange={e => setEmail(e.target.value)}
          />
        </div>

        <div className="input-group mb-2">
          <div className="input-group-prepend">
            <span className="input-group-text">
              <i className="fa fa-key" />
            </span>
          </div>
          <input
            type="password"
            className="form-control"
            id="password"
            placeholder="Password"
            onChange={e => setPassword(e.target.value)}
          />
        </div>
        {showErrorText && (
          <div>
            <small className="form-text text-danger">
              The username or password was incorrect
            </small>
          </div>
        )}
        <button
          type="submit"
          className="btn btn-primary mt-2"
          disabled={inProgress}
        >
          Log in {inProgress && <i className="fa fa-spinner fa-spin" />}
        </button>

        {validEmail && !passEmailSent && (
          <div>
            <button
              disabled={sendingPassResetEmail}
              type="button"
              className="btn btn-sm btn-link pl-0 mt-2"
              onClick={sendPasswordResetEmail}
            >
              Send password reset email{' '}
              {sendingPassResetEmail && <i className="fa fa-spinner fa-spin" />}
            </button>
          </div>
        )}

        {passEmailSent && (
          <div className="mt-2">
            <small className="text-primary">
              The email to reset your password has been sent{' '}
              <i className="fa fa-check" />
            </small>
          </div>
        )}
      </form>
    </div>
  )
}

export default Login
